/* CRO mobile-conversion #2 (2026-07): scroll the theme-owned rating link to the review section.
   Klaviyo Reviews since 2026-09-29: target is the Klaviyo product-reviews app block wrapper. */
(function () {
  var HEADER_OFFSET = 80; // sticky header + breathing room (~73px header measured live)

  function findReviews() {
    var direct = document.getElementById('reviews');
    if (direct) { return direct; }
    var el = document.querySelector(
      '[id*="klaviyo_reviews_product_reviews"]'
    );
    if (el) { return el.closest('[id^="shopify-section-"]') || el; }
    return null;
  }

  document.addEventListener('click', function (e) {
    var link = e.target.closest ? e.target.closest('.pdp-rating') : null;
    if (!link) { return; }
    var target = findReviews();
    if (!target) { return; } // nothing to scroll to; leave the inert #reviews href
    e.preventDefault();
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var y = target.getBoundingClientRect().top + window.pageYOffset - HEADER_OFFSET;
    window.scrollTo({ top: y, behavior: reduce ? 'auto' : 'smooth' });
  });
})();
